import { type StateCreator } from 'zustand';

export type MainSideNavPinSlice = {
  pinned: boolean;
  setPinned: (pinned: boolean) => void;
  togglePinned: () => void;
};

export type CreateMainSideNavPinSlice = (
  initialState: Pick<Partial<MainSideNavPinSlice>, 'pinned'>,
) => StateCreator<MainSideNavPinSlice, [], [], MainSideNavPinSlice>;

export const createMainSideNavPinSlice: CreateMainSideNavPinSlice = (initialState) => (set) => ({
  pinned: initialState.pinned ?? false,
  setPinned: (pinned) => set({ pinned }),
  togglePinned: () => set((state) => ({ pinned: !state.pinned })),
});
